module.exports = function() {
  return new Worker(__webpack_public_path__ + "5ca274711e9d9e3123d9.worker.js");
};